<template>
  <div class="goods">
    <div v-show="$route.path.indexOf('detail') == -1">
      <div class="top">
        <el-carousel arrow="always" height="5rem" class="pc">
          <el-carousel-item v-for="(item,index) in banner" :key="index">
            <img :src="item.img" alt />
          </el-carousel-item>
        </el-carousel>
        <swiper :option="option" class="mobile">
          <swiper-slide v-for="(item,index) in banner" :key="index">
            <img :src="item.img" alt />
          </swiper-slide>
        </swiper>
      </div>
      <main
        v-for="(item,index) in is_top"
        :key="index"
        :class="index !== is_top.length-1?'odd':'even'"
        class="special-top"
      >
        <h1>精選系列</h1>
        <span></span>
        <div>
          <div class="image pc" :style="{backgroundImage:`url(${item.img[0]})`}"></div>
          <img :src="item.img[0]" class="image mobile" />
          <div class="inner">
            <p class="title">{{item.title}}</p>
            <p class="no">{{item.code}}</p>
            <p class="text-overflow-more text-overflow-more-4">{{item.intro}}</p>
            <p>
              <span @click="toDetail(item.id)">查看詳細介紹</span>
            </p>
          </div>
        </div>
      </main>
      <div class="box">
        <h1>全部产品</h1>
        <span></span>
      </div>
      <main class="all-good">
        <div v-for="(item,index) in list" :key="index">
          <div class="image pc" :style="{backgroundImage:`url(${item.img[0]})`}"></div>
          <img :src="item.img" class="image mobile" />
          <div class="inner">
            <p class="title">{{item.title}}</p>
            <p>
              <span @click="toDetail(item.id)">查看詳細介紹</span>
            </p>
          </div>
        </div>
      </main>
      <div class="btn" @click="more">加载更多</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      type: 1,
      is_top: [],
      banner: [],
      list: [],
      option: {
        loop: true,
        autoplay: true,
      },
    };
  },
  created() {
    let route = this.$route.path;
    let banner;
    switch (route) {
      case "/jadeite":
        this.type = 1;
        banner = 2;
        break;
      case "/emerald":
        this.type = 2;
        banner = 3;
        break;
      default:
        break;
    }
    this.getData();
    this.getList();
    this.axios
      .post("banner/index", {
        nav_id: banner,
      })
      .then((r) => {
        console.log(r);
        this.banner = r || [];
      });
  },
  watch: {
    "$route.path": {
      handler() {
        location.reload();
      },
    },
  },
  methods: {
    more() {
      this.page = this.page + 1;
      this.getList();
    },
    toDetail(id) {
      console.log(id);
      this.$router.push({
        path: this.$route.path + "/detail",
        query: {
          id,
        },
      });
    },
    getData() {
      this.axios
        .post("product/index", {
          category_id: this.type,
          per_page: 1,
          is_top: 1,
        })
        .then((r) => {
          this.is_top = [...r.data];
        });
    },
    getList() {
      this.axios
        .post("product/index", {
          category_id: this.type,
          per_page: 8,
          page: this.page,
        })
        .then((r) => {
          this.list = this.list.concat([...r.data]);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  height: 5.4rem;
  color: #f7f7f7;
  padding: 0.2rem;
  box-sizing: border-box;

  .el-carousel {
    img {
      width: 16.5rem;
      height: 5rem;
      object-fit: cover;
      margin: 0 auto;
      display: block;
    }
  }
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 0.5rem;

  & > span {
    width: 0.79rem;
    height: 1px;
    background: black;
    margin-top: 0.66rem;
    display: inline-block;
  }
}

main.special-top {
  padding: 1rem 3.6rem;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  & > span {
    width: 0.79rem;
    height: 1px;
    background: black;
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
  }

  & > div {
    display: flex;
    width: 100%;

    & > * {
      width: 50%;
      height: 5.8rem;
    }

    .image {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      transition: all 0.3s linear;
      width: 5.8rem;
    }

    .image:hover {
      background-size: 110% 110%;
    }

    .inner {
      background: #f7f7f7;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 0.86rem;
      box-sizing: border-box;

      p {
        width: 100%;

        span {
          font-size: 0.14rem;
          font-family: "FZShuSong-Z01T";
          padding: 0.1rem;
          border-bottom: 1.5px solid lightgray;
          cursor: pointer;
          transition: all 0.3s linear;
        }

        span:hover {
          padding: 0.1rem 0;
        }
      }

      .title {
        font-size: 0.2rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;
      }

      .no {
        font-size: 0.16rem;
        font-family: "Baskerville Old Face";
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
      }

      .text-overflow-more {
        font-size: 0.14rem;
        // font-family: "FZShuSong-Z01T";
        margin-bottom: 0.7rem;
        line-height: 0.4rem;
      }
    }
  }
}

main.all-good {
  padding: 1rem 0;
  background: white;
  display: flex;
  flex-wrap: wrap;
  width: 12rem;
  margin: 0 auto;

  & > span {
    width: 0.79rem;
    height: 1px;
    background: black;
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
  }

  & > div {
    width: 25%;
    padding: 20px;
    box-sizing: border-box;

    .image {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      cursor: pointer;
      transition: all 0.3s linear;
      width: 2.5rem;
      height: 2.5rem;
    }

    .image:hover {
      background-size: 110% 110%;
    }

    .inner {
      background: #f7f7f7;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;

      p {
        width: 100%;

        span {
          font-size: 0.14rem;
          font-family: "FZShuSong-Z01T";
          padding: 0.1rem;
          border-bottom: 1.5px solid lightgray;
          cursor: pointer;
          transition: all 0.3s linear;
        }

        span:hover {
          padding: 0.1rem 0;
        }
      }

      .title {
        font-size: 0.2rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;
        margin-bottom: 20px;
      }

      .no {
        font-size: 0.16rem;
        font-family: "Baskerville Old Face";
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
      }

      .text-overflow-more {
        font-size: 0.14rem;
        font-family: "FZShuSong-Z01T";
        margin-bottom: 0.2rem;
        line-height: 0.2rem;
      }
    }
  }
}

main.even {
  background: #f7f7f7;

  & > div {
    .inner {
      background: white;
    }
  }
}

.btn {
  width: 3.29rem;
  height: 0.59rem;
  background: rgba(0, 0, 0, 1);
  margin: 0.9rem auto 0;
  cursor: pointer;
  text-align: center;
  line-height: 0.59rem;
  color: white;
  font-size: 0.16rem;
  font-family: FZShuSong-Z01T;
  transition: all 0.3s linear;
  user-select: none;
}

.btn:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}

.btn:active {
  opacity: 0.58;
}

@media (max-width: 767px) {
  h1 {
    font-size: 16px;
  }

  .en {
    font-size: 14px;
  }

  .top {
    height: 150px;

    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }
  }

  main.all-good {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;

    & > div {
      width: 100%;
      padding: 10px;

      .image {
        height: auto;
        width: 100%;
      }

      .inner {
        .title{
          font-size: 1rem;
        }
        p{
          span{
            font-size: .8rem;
          }
        }
        .text-overflow-more {
          line-height: 20px;
        }
      }
    }
  }

  main.special-top {
    padding: 20px 10px;

    & > span {
      width: 30%;
      margin-top: 30px;
      margin-bottom: 20px;
    }

    & > div {
      width: 100%;
      display: block;

      .inner {
        .title {
          font-size: 14px;
        }

        .no {
          font-size: 12px;
        }

        .text-overflow-more {
          font-size: 12px;
          line-height: 20px;
        }

        p {
          span {
            font-size: 12px;
          }
        }
      }

      & > * {
        height: 200px;
        width: 100%;
      }

      & > .inner {
      }

      .image {
        width: 100% !important;
        height: auto;
      }
    }
  }

  .btn {
    width: 50%;
    font-size: 14px;
    padding: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods.vue